import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTES_PATHS } from 'const'

import styles from './styles/accent_block_component.module.scss'

const AccentBlockComponent = ({ image, title }) => {
  return (
    <section className={styles.accent_block_component}>
      <div className={styles.accent_block_component__content}>
        <h2 className={styles.accent_block_component__content_title}>
          {title}
        </h2>
        <Link
          to={ROUTES_PATHS.USEFUL}
          className={styles.accent_block_component__content_button}
        >
          <div className={styles.accent_block_component__content_button_title}>
            Как купить дешевле?
          </div>
        </Link>
      </div>
      <img loading="lazy"
      className={styles.accent_block_component__img}
        src={image}
        width='635px'
        height='314px'
        alt=""
      />
    </section>
  )
}

export default AccentBlockComponent